/*
  Cart timer (T033). Honest by construction: the countdown is only shown while the cart has items, it starts once when the
  cart goes from empty to non-empty, never restarts on its own, and at zero the cart really is emptied (/cart/clear.js).
  No price or stock is claimed. No timer in the theme editor (design mode) and none when browser storage is unavailable.
  The start time lives in localStorage so a reload, another page or a returning visitor sees the same remaining time.
  The page itself says whether the cart has items: the server renders [data-tv-cart-timer] only for a non-empty cart and
  [data-tv-cart-timer-note] only for an empty one (Dawn re-renders the drawer after every cart change), so no cart events are hooked.
*/
(function () {
  if (window.tvCartTimerLoaded) return;
  window.tvCartTimerLoaded = true;

  var script = document.querySelector('script[data-tv-cart-timer-script]');
  if (!script) return;

  var duration = Math.max(1, parseInt(script.getAttribute('data-minutes'), 10) || 5) * 60000;
  var START_KEY = 'tv_cart_timer_start';
  var NOTE_KEY = 'tv_cart_timer_emptied';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var busy = false;

  function read(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function write(key, value) {
    try {
      window.localStorage.setItem(key, value);
      return window.localStorage.getItem(key) === String(value);
    } catch (e) {
      return false;
    }
  }

  function remove(key) {
    try {
      window.localStorage.removeItem(key);
    } catch (e) {}
  }

  function format(ms) {
    var total = Math.max(0, Math.ceil(ms / 1000));
    var minutes = Math.floor(total / 60);
    var seconds = total % 60;
    return (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
  }

  function setHidden(list, hidden) {
    for (var i = 0; i < list.length; i++) list[i].hidden = hidden;
  }

  // the page is being replaced: the returned promise never settles, so tick() stays paused and the old markup is never read
  function reloadPage() {
    window.location.reload();
    return new Promise(function () {});
  }

  // re-draws the drawer / cart page after the cart has been emptied
  function refresh() {
    if (/\/cart\/?$/.test(window.location.pathname)) return reloadPage();
    return fetch(root + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (response) {
        return response.json();
      })
      .then(function (sections) {
        var parse = function (html) {
          return new DOMParser().parseFromString(html, 'text/html');
        };
        var drawer = document.querySelector('#CartDrawer');
        var fresh = sections['cart-drawer'] && parse(sections['cart-drawer']).querySelector('#CartDrawer');
        if (drawer && fresh) drawer.innerHTML = fresh.innerHTML;
        var drawerElement = document.querySelector('cart-drawer');
        if (drawerElement) drawerElement.classList.add('is-empty', 'custom-cart-drawer--empty');
        var bubble = document.getElementById('cart-icon-bubble');
        var freshBubble = sections['cart-icon-bubble'] && parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
        if (bubble && freshBubble) bubble.innerHTML = freshBubble.innerHTML;
      });
  }

  // if the drawer cannot be re-drawn in place, a reload shows the empty cart (and the message) instead
  function redraw() {
    return refresh().catch(reloadPage);
  }

  // while the cart is being emptied the old markup is still on the page: tick() must not read it as a new cart
  function expire() {
    if (busy) return;
    busy = true;
    var failed = false;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        // the cart was already emptied elsewhere (for example paid in another tab): nothing to clear, no message
        if (cart.item_count === 0) {
          remove(START_KEY);
          return redraw();
        }
        return fetch(root + 'cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } }).then(function (response) {
          if (!response.ok) throw new Error('clear failed');
          remove(START_KEY);
          write(NOTE_KEY, '1');
          return redraw();
        });
      })
      .catch(function () {
        // keep the start time and try again shortly; the timer must not silently restart
        failed = true;
      })
      .then(function () {
        if (failed) {
          window.setTimeout(function () {
            busy = false;
          }, 3000);
        } else {
          busy = false;
          tick();
        }
      });
  }

  function tick() {
    if (busy) return;
    var timers = document.querySelectorAll('[data-tv-cart-timer]');
    var notes = document.querySelectorAll('[data-tv-cart-timer-note]');

    if (designMode) {
      // preview in the theme editor: show the full duration, never touch storage or the cart
      for (var d = 0; d < timers.length; d++) {
        var shown = timers[d].querySelector('[data-tv-cart-timer-value]');
        if (shown) shown.textContent = format(duration);
      }
      setHidden(timers, false);
      setHidden(notes, true);
      return;
    }

    if (timers.length) {
      // the cart has items: start the timer once, keep it until the cart is empty
      var start = parseInt(read(START_KEY), 10);
      if (!start) {
        start = Date.now();
        if (!write(START_KEY, start)) {
          setHidden(timers, true); // storage unavailable: no timer rather than a fake one
          return;
        }
        remove(NOTE_KEY);
      }
      var left = start + duration - Date.now();
      if (left <= 0) {
        expire();
        left = 0;
      }
      for (var i = 0; i < timers.length; i++) {
        var value = timers[i].querySelector('[data-tv-cart-timer-value]');
        if (value) value.textContent = format(left);
      }
      setHidden(timers, false);
    } else if (notes.length) {
      // the cart is empty: the next add starts a new timer; the message stays until then
      remove(START_KEY);
      setHidden(notes, read(NOTE_KEY) !== '1');
    }
  }

  tick();
  window.setInterval(tick, 1000);
  window.addEventListener('pageshow', tick);
})();
